import React, { useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import { type HSIconSeqFrame, ImageType } from '@types';
import { Validator } from '@components/Validator';
import ImageContainer from '@components/ImageContainer';
import Tip from '@components/Tip';
import Button from '@components/Button';
import Image from '@components/Image';
import getImageSize from '@utils/getImageSize';
import { getMediaUrl } from '@utils/urlMakers';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import { $playerWidgetsApi } from '@stores/playerWidgets';
import { reAddEditingHotspot } from '../../../../hotspot';
import { selectLibImages } from '../../../../mediaLib';
import FrameSetting from './FrameSetting';
import StickSetting from '../StickSetting';

function IconSettingSeqFrame() {
  const { hotspot } = useStore($editingHotspot)!;
  const icon = hotspot.icon as HSIconSeqFrame;
  const seqFrame = icon.media[0];
  const [settingKey, setKey] = useState(0);

  useEffect(() => {
    return () => {
      $playerWidgetsApi.remove('icon');
    };
  }, []);

  useEffect(() => {
    if (seqFrame) {
      $playerWidgetsApi.add('icon');
    } else {
      $playerWidgetsApi.remove('icon');
    }
  }, [!seqFrame]);

  const handleSelectImage = async () => {
    const { libItems } = await selectLibImages();
    if (!libItems) return;
    const item = libItems[0];
    const size = await getImageSize(getMediaUrl(item.url));
    if (!size) return;
    $editingHotspotApi.update((draft) => {
      (draft.icon as HSIconSeqFrame).media = [
        {
          id: item.id,
          url: item.url,
          frame: Math.ceil(size.height / size.width),
          duration: 0.05,
          ...size,
        },
      ];
    });
    reAddEditingHotspot();
    setKey((v) => v + 1);
  };

  const handleFrameDelete = () => {
    $editingHotspotApi.update((draft) => {
      (draft.icon as HSIconSeqFrame).media = [];
    });
    reAddEditingHotspot();
  };

  const handleSettingChange = (params: { frame: number; duration: number }) => {
    $editingHotspotApi.update((draft) => {
      const frameData = (draft.icon as HSIconSeqFrame).media[0]!;
      frameData.frame = params.frame;
      frameData.duration = params.duration;
    });
    reAddEditingHotspot();
  };

  return (
    <>
      <Validator
        value={seqFrame}
        validFn={(value) => !!value}
        warningMessage="请选择图片"
      >
        {({ warning, value }) => (
          <ImageContainer
            warning={warning}
            className="h-155"
            onDeleteClick={handleFrameDelete}
            placeholder={
              <div className="flex flex-col items-center">请选择序列帧图片</div>
            }
          >
            {!!value && (
              <Image
                src={value.url}
                type={ImageType.media}
                className="max-h-full max-w-full"
              />
            )}
          </ImageContainer>
        )}
      </Validator>
      <div className="mt-10 flex items-center justify-between">
        <Tip>图片最大宽度300PX</Tip>
        <Button size="sm" onClick={handleSelectImage}>
          选择图片
        </Button>
      </div>
      {seqFrame && (
        <>
          <FrameSetting
            key={settingKey}
            frame={seqFrame.frame}
            duration={seqFrame.duration}
            onChange={handleSettingChange}
          />
          <StickSetting />
        </>
      )}
    </>
  );
}

export default IconSettingSeqFrame;
